<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
    <el-row :gutter="20">
      <el-text>名称：</el-text>
      <el-col :span="4">
        <el-input
          placeholder="请输入内容"       
          clearable
          v-model="txt1">
          </el-input>  
      </el-col>
      <el-row>
        <el-button @click="searchPage" :icon="search" circle>
          <el-icon><Search /></el-icon>
        </el-button>
      </el-row>
    </el-row>
    <!-- 新增、批量删除按钮 -->
    <el-row class="bt">
    </el-row>
    <!-- 管理列表 -->
    <el-table :data="tableData" style="width:100%">
      <el-table-column label="提现会员">
        <template #default="scope">
          <p>{{ scope.row.nickname }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawTypeName" label="提现类型" />
      <el-table-column label="提现数量">
        <template #default="scope">
          <span v-if="scope.row.withdrawType==1">{{ scope.row.withdrawMoney?scope.row.withdrawMoney+"元":"--" }}</span>
          <span v-if="scope.row.withdrawType==2">{{ scope.row.withdrawMoney?scope.row.withdrawMoney+"邮票":"--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="到账金额">
        <template #default="scope">
          <span>{{ scope.row.realMoney?scope.row.realMoney+"元":"--" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="addDate" label="提现日期" />
      <el-table-column prop="complateDate" label="完成日期" />
      <el-table-column prop="stateName" label="状态" />
      <el-table-column prop="remark" label="备注" />

      <el-table-column fixed="right" label="操作" width="150">
        <template #default="scope">
          <el-button link type="primary" size="small" v-if="scope.row.state == 1" @click="handleEdit(scope.row)">审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="kh-page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="currentPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
  </el-card>
</div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 10,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/WithdrawLogsEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page: this.currentPage,
          pageSize: this.currentPageSize,
          sortField: ''
        }
        ths.$post('/Users/queryWithdrawPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
              ths.totalCount = res.data.records
            }else{
              ths.tableData = [];
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/WithdrawLogsEdit?id="+row.id)
      },
      handleSizeChange(val) {
        this.currentPageSize = val
        this.getPage()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPage()
      },
      searchPage(){
        this.currentPage = 1
        this.getPage()
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>